.radio {
  position: relative;
  display: flex;
  gap: var(--ism-spacing-xs);
  align-items: center;
  margin-bottom: 0;
  font-size: var(--ism-font-size-body-l);
  color: var(--ism-color-on-surface);
  cursor: pointer;
}

.radio[data-hovered] {
  color: var(--ism-color-on-surface);
}

.radio[data-disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.regular {
  font-family: var(--ism-typeface-regular);
}

.bold {
  font-family: var(--ism-typeface-bold);
}

.iconLeft {
  flex-direction: row;
}

.iconRight {
  flex-direction: row-reverse;
}

.radioIcon {
  display: grid;
  place-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin: 2px;
  border: 2px solid var(--ism-color-on-surface-variant);
  border-radius: var(--ism-radius-full);
}

.radioIcon::before {
  width: 12px;
  height: 12px;
  content: "";
  background-color: var(--ism-color-on-surface);
  border-radius: var(--ism-radius-full);
  transition: 120ms transform ease-in-out;
  transform: scale(0);
}

.radio[data-hovered] .radioIcon {
  background-color: color-mix(
    in srgb,
    var(--ism-color-on-primary),
    var(--ism-color-primary) 5%
  );
  border-color: var(--ism-color-on-surface);
  outline: 2px solid
    color-mix(in srgb, var(--ism-color-on-primary), var(--ism-color-primary) 5%);
}

.radio[data-focus-visible] .radioIcon {
  outline: 2px solid var(--ism-color-focused);
}

.radio[data-selected] .radioIcon,
.radio[data-selected] .radioIcon::before {
  border-color: var(--ism-color-on-surface);
  transform: scale(1);
}

.radio[data-invalid] .radioIcon {
  border-color: var(--ism-color-error);
}

.radio[data-invalid] .radioIcon::before {
  background-color: var(--ism-color-error);
}

.radioLabel {
  display: flex;
  align-items: center;
}

.radioContainer {
  display: flex;
  flex-direction: column;
  gap: var(--ism-spacing-xs);
}

.radioContainer:not(:last-child) {
  padding-bottom: var(--ism-spacing-m);
  border-bottom: 1px solid var(--ism-color-outline-variant);
}

.radioDescription {
  font-size: var(--ism-font-size-body-m);
  color: var(--ism-color-on-surface-variant);
  align-self: flex-start;
}
